import { useState } from "react";
import { Button } from "@/shared/ui/Button";
import type { LedgerAllocationOperationType } from "../../types/accounting.types";

/**
 * ADM-621 - catégories désactivées, repliées par défaut : elles sont souvent
 * nombreuses (héritage de plusieurs exercices) et n'ont qu'un geste utile, la
 * réactivation. Un tableau complet leur donnerait le même poids visuel qu'aux
 * actives. Partagé entre la page Budgets et le drawer DRW-CATMGR.
 */
const InactiveCategories = ({
  categories,
  onEnable,
}: {
  categories: LedgerAllocationOperationType[]
  onEnable: (id: string) => void
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-md border bg-slate-50/60">
      <button
        type="button"
        className="flex w-full items-center justify-between px-3 py-2 text-xs font-medium text-slate-600"
        onClick={() => setOpen((previous) => !previous)}
      >
        <span>
          Catégories inactives (
          {categories.length}
          )
        </span>
        <span className="text-slate-400">{open ? "Masquer" : "Afficher"}</span>
      </button>
      {open && (
        <ul className="divide-y divide-slate-100 border-t border-slate-100">
          {categories.map((category) => (
            <li key={category.id} className="flex items-center justify-between px-3 py-1.5 text-xs">
              <span className="text-slate-700">{category.name}</span>
              <Button variant="outline" size="sm" className="h-6 px-2 text-[11px]" onClick={() => onEnable(category.id)}>
                Réactiver
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InactiveCategories;
